<template>
    <Layout>
        <b-card>
            <b-tabs v-model="activeTab" content-class="mt-3">
                <!-- Aba 1: Cadastro de Formulários -->
                <b-tab title="Cadastro de Formulários" :title-link-class="linkClass(0)">
                    <FilterBase
                        session="Form"
                        :filter="filter"
                        :button="true"
                        url="/formularios/cadastrar"
                    />

                    <div class="mb-0 mt-3">
                        <TableList
                            session="Form"
                            url="formularios/"
                            :table="table"
                            :keys="keys"
                            :key="tableKey"
                        >

                            <template #title="{value}">

                                <router-link :to="'/formularios/cadastrar/' + value.id">

                                    <div class="media flex-nowrap align-items-center"
                                         style="white-space: nowrap;">
                                        <div class="media-body">

                                            <div class="d-flex flex-column">
                                                <p class="mb-0">
                                                    <strong class="js-lists-values-name text-link">{{
                                                            value.title
                                                        }}</strong>
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </router-link>

                            </template>

                            <template #total_questions="{value}">
                                <span>{{ value.total_questions || 0 }}</span>
                            </template>

                            <template #actions="{value}">
                                <Actions
                                    session="Form"
                                    :id="value.id"
                                    :types="types"
                                    @refreshTable="refreshTable()"
                                    api="forms/"
                                    url="formularios/"
                                />
                                <!-- <a :href="`${env.menteeUrl}formulario/preview/${encondeId(value.id)}`" target="_blank">
                                    <i class="fa fa-search text-muted mx-1" title="Preview"></i>
                                </a> -->
                            </template>

                        </TableList>
                    </div>
                </b-tab>

                <!-- Aba 2: Consulta de Respostas -->
                <b-tab title="Consulta de Respostas" :title-link-class="linkClass(1)">
                    <FilterBase
                        session="FormResponses"
                        :filter="responsesFilter"
                        :button="false"
                    />

                    <div class="mb-0 mt-3">
                        <TableList
                            session="FormResponses"
                            url="forms/responses/all"
                            :table="responsesTable"
                            :keys="responsesKeys"
                            :key="responsesTableKey"
                        >
                            <template #name="{value}">
                                <div class="media flex-nowrap align-items-center">
                                    <div class="media-body">
                                        <div class="d-flex flex-column">
                                            <p class="mb-0">
                                                <strong class="js-lists-values-name">{{ value.name }}</strong>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template #email="{value}">
                                <span>{{ value.email }}</span>
                            </template>

                            <template #form_title="{value}">
                                <span>{{ value.form_title }}</span>
                            </template>

                            <template #status="{value}">
                                <b-badge 
                                    :variant="getStatusVariant(value.status)"
                                    class="text-capitalize"
                                >
                                    {{ getStatusText(value.status) }}
                                </b-badge>
                            </template>

                            <template #has_feedback="{value}">
                                <b-badge 
                                    :variant="value.has_feedback ? 'success' : 'secondary'"
                                >
                                    {{ value.has_feedback ? 'Sim' : 'Não' }}
                                </b-badge>
                            </template>

                            <template #created_at="{value}">
                                <span>{{ formatDate(value.created_at) }}</span>
                            </template>

                            <template #actions="{value}">
                                <div class="d-flex">
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="viewResponse(value)"
                                        class="mr-2"
                                        title="Visualizar Resposta"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                    <b-button
                                        variant="outline-danger"
                                        size="sm"
                                        @click="deleteResponse(value)"
                                        title="Excluir Resposta"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </div>
                            </template>
                        </TableList>
                    </div>

                    <!-- Modal para visualizar resposta -->
                    <b-modal 
                        id="responseModal" 
                        title="Detalhes da Resposta" 
                        size="lg"
                        @hidden="selectedResponse = null"
                    >
                        <div v-if="selectedResponse">
                            <div class="mb-3">
                                <h6>Informações do Candidato</h6>
                                <div class="row">
                                    <div class="col-md-6">
                                        <strong>Nome:</strong> {{ selectedResponse.name }}
                                    </div>
                                    <div class="col-md-6">
                                        <strong>Email:</strong> {{ selectedResponse.email }}
                                    </div>
                                    <div class="col-md-6">
                                        <strong>Telefone:</strong> {{ selectedResponse.phone || 'Não informado' }}
                                    </div>
                                    <div class="col-md-6">
                                        <strong>Data:</strong> {{ formatDate(selectedResponse.created_at) }}
                                    </div>
                                    <div class="col-md-12">
                                        <strong>Formulário:</strong> {{ selectedResponse.form_title }}
                                    </div>
                                    <div class="col-md-12" v-if="selectedResponse.feedback">
                                        <strong>Feedback do Mentor:</strong> {{ selectedResponse.feedback }}
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <h6>Respostas do Formulário</h6>
                            <div v-for="answer in selectedResponse.answers" :key="answer.id" class="mb-3">
                                <div class="card">
                                    <div class="card-body">
                                        <h6 class="card-title">{{ answer.question_title }}</h6>
                                        <p class="card-text">
                                            <span v-if="answer.question_type === 'multiple_choice'">
                                                {{ answer.selected_option || 'Sem resposta' }}
                                            </span>
                                            <span v-else-if="answer.question_type === 'checkbox'">
                                                {{ answer.selected_options ? answer.selected_options.join(', ') : 'Nenhuma opção selecionada' }}
                                            </span>
                                            <span v-else>
                                                {{ answer.text_answer || 'Sem resposta' }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="selectedResponse.feedbacks && selectedResponse.feedbacks.length > 0">
                                <hr>
                                <h6>Feedbacks Adicionais</h6>
                                <div v-for="feedback in selectedResponse.feedbacks" :key="feedback.id" class="mb-3">
                                    <div class="card border-info">
                                        <div class="card-body">
                                            <h6 class="card-title text-info">{{ feedback.section_title }}</h6>
                                            <p class="card-text">{{ feedback.feedback }}</p>
                                            <small class="text-muted">{{ formatDate(feedback.created_at) }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </b-tab>
            </b-tabs>
        </b-card>
    </Layout>

</template>

<script>
/* eslint-disable */
import Layout from '@/components/layout/main.vue';
import TableList from "@/components/base/table-list.vue";
import FilterBase from '@/components/base/filter-component.vue';
import Actions from "@/components/base/actions.vue";
import {filter} from "@/views/forms/js/filter";
import {keys, table} from "@/views/forms/js/table";
import {responsesFilter} from "@/views/forms/js/responses-filter";
import {responsesKeys, responsesTable} from "@/views/forms/js/responses-table";
import {setSessions} from "@/components/composables/setSessions";
import env from '@/env'
import {encondeId} from "@/components/composables/functions";
import http from '@/http';

export default {
    components: {
        Layout,
        FilterBase,
        TableList,
        Actions
    },
    methods: {
        encondeId,
        refreshTable() {
            this.tableKey++;
        },
        linkClass(idx) {
            if (this.activeTab === idx) {
                return ['bg-primary', 'text-white']
            } else {
                return ['bg-light', 'text-dark']
            }
        },
        async loadForms() {
            try {
                const response = await http.get('forms/');
                this.formOptions = response.data.data.map(form => ({
                    value: form.id,
                    text: form.title
                }));
                
                // Atualizar as opções do filtro de formulário
                this.responsesFilter.selects.find(s => s.name === 'form_id').options = [
                    { value: '', text: 'Todos os formulários' },
                    ...this.formOptions
                ];
            } catch (error) {
                console.error('Erro ao carregar formulários:', error);
                this.$toast.error('Erro ao carregar lista de formulários');
                this.formOptions = [];
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getStatusVariant(status) {
            const variants = {
                'pending': 'warning',
                'approved': 'success',
                'rejected': 'danger'
            };
            return variants[status] || 'secondary';
        },
        getStatusText(status) {
            const texts = {
                'pending': 'Pendente',
                'approved': 'Aprovado',
                'rejected': 'Rejeitado'
            };
            return texts[status] || status;
        },
        viewResponse(response) {
            this.selectedResponse = response;
            this.$bvModal.show('responseModal');
        },
        async deleteResponse(response) {
            if (confirm(`Tem certeza que deseja excluir a resposta de ${response.name}?`)) {
                try {
                    await http.delete(`form-applications/${response.id}`);
                    this.$toast.success('Resposta excluída com sucesso!');
                    this.responsesTableKey++; // Forçar re-render da tabela
                } catch (error) {
                    console.error('Erro ao excluir resposta:', error);
                    this.$toast.error('Erro ao excluir resposta');
                }
            }
        }
    },
    data() {
        return {
            types: ['edit', 'delete'],
            tableKey: 0,
            filter,
            table,
            keys,
            env,
            activeTab: 0,
            formOptions: [],
            selectedResponse: null,
            responsesTableKey: 0,
            responsesFilter,
            responsesTable,
            responsesKeys
        }
    },
    mounted() {
        this.$store.commit('form/resetQuestions');
        if (!localStorage.getItem('Form')) setSessions('Form');
        if (!localStorage.getItem('FormResponses')) setSessions('FormResponses');
        this.loadForms();
    }
}
</script>
